export default __webpack_public_path__ + "static/media/failed-image.559962ec.svg";